import { default as heartHealth } from "./heart-health.json";
import { default as modernaOffer } from "./moderna-offer.json";
import { default as programsData } from "./programs.json";

const data: { [key: string]: object } = {
  "default": programsData,
  "heart-health": heartHealth,
  "moderna-offer": modernaOffer,
};

const programs = {
  get: () => data["default"],
  getOne: (programIdentifier: string, offerIdentifier?: string) => {
    if (offerIdentifier) {
      return data[`${programIdentifier}-${offerIdentifier}`];
    }

    return data[programIdentifier];
  },
};

export default programs;
